import { useBookings } from 'core/contexts/booking';
import { useTranslation } from 'react-i18next';
import { CalendarMonth, Category, Description, EventAvailable, Gavel, Groups, People, Reviews } from '@mui/icons-material';
import { Box, Fade, Grid2 } from '@mui/material';
import SectionButton from '../SectionButton';

const SectionButtons = ({ experienceId }) => {
    const { t } = useTranslation();
    const translate = (key) => t(`experience_id.sections.${key}`);
    const { setFilteredExperiences } = useBookings();

    const iconSize = { xs: '1.5rem', md: 'xx-large' };
    const sections = [
        {
            id: 1,
            icon: <Description sx={{ fontSize: iconSize }} />,
            label: translate('profile'),
            path: `/experience/${experienceId}/profile`,
            color: '#137DC5',
        },
        {
            id: 2,
            icon: <CalendarMonth sx={{ fontSize: iconSize }} />,
            label: translate('calendar'),
            path: `/experience/${experienceId}/scheduling`,
            color: '#9EC4D6',
        },
        {
            id: 3,
            icon: <EventAvailable sx={{ fontSize: iconSize }} />,
            label: translate('bookings'),
            path: '/booking',
            onClick: () => {
                const booking = {
                    id: experienceId,
                    checked: true,
                };
                setFilteredExperiences([booking]);
            },
            color: '#50C878',
        },
        {
            id: 4,
            icon: <Category sx={{ fontSize: iconSize }} />,
            label: translate('options'),
            path: `/experience/${experienceId}/options`,
            color: '#A5BA63',
        },
        {
            id: 5,
            icon: <People sx={{ fontSize: iconSize }} />,
            label: translate('resources'),
            path: `/experience/${experienceId}/resource`,
            color: '#F56300',
        },
        {
            id: 6,
            icon: <Groups sx={{ fontSize: iconSize }} />,
            label: translate('units'),
            path: `/experience/${experienceId}/units`,
            color: '#E4954B',
        },
        {
            id: 7,
            icon: <Reviews sx={{ fontSize: iconSize }} />,
            label: translate('reviews'),
            path: `/experience/${experienceId}/reviews`,
            color: '#FACE5D',
            disabled: true,
        },
        {
            id: 8,
            icon: <Gavel sx={{ fontSize: iconSize }} />,
            label: translate('policies'),
            path: `/experience/${experienceId}/terms`,
            color: '#131313',
        },
    ];

    return (
        <Box component="section" display="flex" flexDirection="column" mt="24px" gap="24px">
            <Fade in timeout={300}>
                <Grid2 container size={12} spacing={2}>
                    {sections.map(({ id, icon, label, path, onClick, color, disabled = false }) => (
                        <SectionButton key={id} id={id} icon={icon} label={label} path={path} onClick={onClick} color={color} disabled={disabled} />
                    ))}
                </Grid2>
            </Fade>
        </Box>
    );
};

export default SectionButtons;
